import React from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import TitlePage from 'components/TituloPage';
import FormAtendente from 'containers/Forms/FormAtendente';
import { listarAtendente } from 'routes/paths';
import { fetchAtualizarAtendente } from 'store/fetchActions/fetchAtendente';
import { fetchGetTodasSituacoes, fetchGetTodosCargos } from 'store/fetchActions/fetchInputForm';
import { fetchBuscarSetores } from 'store/fetchActions/fetchSetores';
import { fetchNotificationApp } from 'store/fetchActions/fetchApp';
import { ALERTA, MSG_ATENDENTE_EDITADO_SECESSO, TODOS_CONDICOES_STATUS } from 'utils/consts';
import { montarDadosInputSelect } from 'utils/funcaoPadrao';
import { formatterAtendenteBackToFront, formatterAtendenteFrontToBackUpdate } from 'utils/formatter/atendente';
import { changeInput, validarExibirErrosCampos } from 'utils/formUtils';
import { validationsAtendenteCreateUpdate } from 'utils/validate/atendente';
import * as S from '../styles';

export default function PageEditarAtendente() {
  const dispatch = useDispatch();
  const history = useHistory();

  const user = useSelector(state => state.sefaz.userProfile);
  const atendente = useSelector(state => state.atendente?.atendenteDetalhar);

  const inputSelectOptionsCargo = useSelector(state => state.inputs.inputSelectOptionsCargo);
  const inputSelectOptionsSituacao = useSelector(state => state.inputs.inputSelectOptionsSituacao);
  const inputSelectOptionsSetores = useSelector(state => state.inputs.inputSelectOptionsSetores);

  React.useEffect(() => {
    dispatch(fetchGetTodosCargos(inputSelectOptionsCargo));
    dispatch(fetchGetTodasSituacoes(inputSelectOptionsSituacao));
    dispatch(fetchBuscarSetores());
    // eslint-disable-next-line
  }, [dispatch]);

  const {
    control,
    handleSubmit,
    setValue,
    setError,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: formatterAtendenteBackToFront(atendente),
  });

  const handleChange = e => {
    changeInput(e, setValue, errors, setError);
  };

  const onSubmit = data => {
    if (validarExibirErrosCampos(data, validationsAtendenteCreateUpdate, setError)) {
      const dadosFormatados = formatterAtendenteFrontToBackUpdate(data, user?.cpf_cnpj);
      dispatch(fetchAtualizarAtendente(dadosFormatados)).then(() => {
        history.push(listarAtendente);
        fetchNotificationApp(MSG_ATENDENTE_EDITADO_SECESSO, '', ALERTA.SUCESSO);
      });
    }
  };

  return (
    <S.Contain className="boxShadow">
      <TitlePage textTitle={'EDITAR DE ATENDENTE'} backPage={listarAtendente} />
      <form>
        <FormAtendente
          errors={errors}
          control={control}
          handleChange={handleChange}
          getValues={getValues}
          optionsCargos={montarDadosInputSelect(inputSelectOptionsCargo, 'id', 'descricao')}
          optionsSituacoes={montarDadosInputSelect(inputSelectOptionsSituacao, 'id', 'descricao')}
          optionsSetores={montarDadosInputSelect(inputSelectOptionsSetores, 'id', 'nome')}
          optionsCondicao={montarDadosInputSelect(TODOS_CONDICOES_STATUS, 'id', 'label')}
          handleSubmit={handleSubmit}
          onSubmit={onSubmit}
          isEditar={true}
          disabled={false}
        />
      </form>
    </S.Contain>
  );
}
